import { ticketBookingPath, isCharityTicket } from './ticket';
import { TicketAvailability } from '../enums';

export const hasRegistrationPerks = (raceSummary) =>
  raceSummary &&
  raceSummary.bookingPartner &&
  raceSummary.bookingPartner.id !== 3 &&
  !raceSummary.hasCharityraceSummarys;

export const areTicketsAvailable = (ticketSummary) => {
  return (
    ticketSummary &&
    ticketSummary.availabilityType.type === TicketAvailability.AVAILABLE
  );
};

/*
 * Filter an array of tickets for those that are currently available
 */
export function onlyAvailableTickets(tickets) {
  return tickets.filter(
    (ticket) => ticket.availabilityType.type === TicketAvailability.AVAILABLE,
  );
}

/*
 * Filter an array of tickets for those that are currently bookable
 */
export function onlyBookableTickets(tickets) {
  return tickets.filter((ticket) => ticket.bookingEnabled);
}

/*
 * Should this RaceSummary link directly to the booking form?
 *
 * True if there is exactly one ticket which is not a charity ticket
 *
 * If true, returns the ticket. Otherwise returns false.
 */
export function shouldLinkDirectlyToBookingForm(tickets, appContext) {
  const availableTickets = onlyAvailableTickets(tickets);

  if (appContext) {
    return availableTickets[0];
  }
  if (availableTickets.length === 1 && !isCharityTicket(availableTickets[0])) {
    return availableTickets[0];
  }
  return false;
}

export const LinkType = {
  BOOKING_FORM: 'BOOKING_FORM',
  TICKET_PAGE: 'TICKET_PAGE',
  CLICK_OUT: 'CLICK_OUT',
};

export const getTicketLink = (ticketsSummary, raceId, router) => {
  if (!areTicketsAvailable(ticketsSummary)) return null;

  // Only consider available.
  const availableTickets = onlyAvailableTickets(ticketsSummary.tickets);
  if (shouldLinkDirectlyToBookingForm(availableTickets)) {
    const ticket = availableTickets[0];
    // Forward to internal booking.
    return ticket.bookingEnabled
      ? {
          type: LinkType.BOOKING_FORM,
          to: ticketBookingPath(ticket.id),
        }
      : {
          type: LinkType.CLICK_OUT,
          to: ticket.bookingUrl,
        };
  }

  // If not linking to booking form, link to the ticketing page.
  const racePath = raceId ? `/${raceId}` : '';
  return {
    type: LinkType.TICKET_PAGE,
    to: `${router.location.pathname}/tickets${racePath}`,
  };
};
